import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';
import projectKeys from './keyFactory';

export const solarDesignDraftsKey = (projectId: string) =>
  [...projectKeys.project(projectId), 'solarDesignDrafts'] as const;

const SolarDesignDrafts = graphql(`
  query SolarDesignDrafts($projectId: ID!) {
    projectById(id: $projectId) {
      publicId
      solarDesignDrafts {
        id
        name
        description
        revision
        basis
        updatedAt
        isStale
        isUsedByEstimate
      }
    }
  }
`);

export const useSolarDesignDrafts = (projectId: string) =>
  useQuery({
    queryKey: solarDesignDraftsKey(projectId),
    queryFn: () => gqlClient.request(SolarDesignDrafts, { projectId }),
  });
